// extracted by mini-css-extract-plugin
export default {"filter_section":"MargemObjetivaSkeleton_filter_section__iXNh-","table_heading":"MargemObjetivaSkeleton_table_heading__0QgvQ"};